// ============================================================
// DEMO / PLACEHOLDER BUSINESS DATA
// Replace all values below with the real client's information.
// Phone, email, address, hours, and social links are FICTIONAL.
// ============================================================

export const business = {
  name: "Empire Home Services",              // TODO: replace with real business name
  tagline: "NYC's Trusted Plumbing, Electrical & HVAC Contractor",
  phoneDisplay: "(212) 555-0199",            // TODO: replace with real phone
  phoneHref: "tel:+12125550199",             // TODO: replace with real phone (tel: link)
  email: "hello@empirehomeservicesny.com",       // business contact email
  emailHref: "mailto:hello@empirehomeservicesny.com",
  address: "123 Broadway Ave, Suite 400, New York, NY 10007", // TODO: replace
  hours: [
    { day: "Mon – Fri", time: "7:00 AM – 7:00 PM" },
    { day: "Saturday", time: "8:00 AM – 4:00 PM" },
    { day: "Sunday", time: "Emergency Service Only" },
  ],
  emergencyLine: "24/7 Emergency Service Available",
  yearsInBusiness: 18,
  license: "NYC Lic. #PL-000000 / EL-000000", // TODO: replace with real license numbers
};

// Social links: placeholders. Do NOT publish fake links.
// Set `url` to the real profile when available. `pending: true` marks it as "add later".
export const socials = [
  { name: "Facebook", icon: "Facebook", url: "https://www.facebook.com/empirehomeservicesny", pending: false },
  { name: "Instagram", icon: "Instagram", url: "https://www.instagram.com/empirehomeservicesny/", pending: false },
  { name: "LinkedIn", icon: "Linkedin", url: "", pending: true },   // TODO: PASTE LINKEDIN URL
  { name: "Google Business Profile", icon: "MapPin", url: "", pending: true }, // TODO: PASTE GBP URL
];

export const IMG = {
  hero: "https://images.pexels.com/photos/18388935/pexels-photo-18388935.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  plumbing: "https://images.pexels.com/photos/29226620/pexels-photo-29226620.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  electrical: "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBvbiUyMHBhbmVsfGVufDB8fHx8MTc4MzEzNzQ2OHww&ixlib=rb-4.1.0&q=85",
  hvac: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// AI-generated sample project images (clearly labeled in the UI)
const PROJECT_IMG = {
  plumbingBefore: "https://static.prod-images.emergentagent.com/jobs/3e28b181-3655-4528-815d-6c1e75a3ff1e/images/89e501a3b9b49bb700fa491cc3a3b37d18636ac93872ead5b18f66cab9247446.png",
  plumbingAfter: "https://static.prod-images.emergentagent.com/jobs/3e28b181-3655-4528-815d-6c1e75a3ff1e/images/8cfb5eec672c97e647a993d372d49b0946141070ac7f525df366fa7e0a122607.png",
  electricalBefore: "https://static.prod-images.emergentagent.com/jobs/3e28b181-3655-4528-815d-6c1e75a3ff1e/images/858815921f1c2139405262c53f5a340a1c9093821e2499674af290dd53899fea.png",
  electricalAfter: "https://static.prod-images.emergentagent.com/jobs/3e28b181-3655-4528-815d-6c1e75a3ff1e/images/783d9ef5e4466dedaf1d7afc426037df16caebf8c1fc3c6180bf2908fd882e54.png",
  hvacBefore: "https://static.prod-images.emergentagent.com/jobs/3e28b181-3655-4528-815d-6c1e75a3ff1e/images/ee676ada079756b6ab41fac6e2a39771534888857f4a1a1fd7a9ce85f5a4a5f6.png",
  hvacAfter: "https://static.prod-images.emergentagent.com/jobs/3e28b181-3655-4528-815d-6c1e75a3ff1e/images/c354a4312ab368d97cd8fe794713cd5b32e44d3c8f3845374162099aa71aa344.png",
};

export const services = [
  {
    slug: "plumbing",
    name: "Plumbing",
    icon: "Wrench",
    image: IMG.plumbing,
    tagline: "Licensed Plumbers in New York",
    short: "Leak repair, drain cleaning, water heaters, pipe replacement, and 24/7 emergency plumbing across NYC.",
    seoTitle: "Plumber New York | Plumbing Services & Emergency Repair | " + business.name,
    seoDesc: "Licensed plumbers in New York for leak repair, drain cleaning, water heater installation & 24/7 emergency plumbing. Request a free estimate today.",
    overview:
      "From a dripping faucet to a burst pipe at 2 AM, our licensed New York plumbers handle it all. We combine upfront pricing, clean workmanship, and fast response times so your home stays dry, safe, and running.",
    problems: [
      "Burst, frozen, or leaking pipes",
      "Clogged drains & sewer line backups",
      "Water heater repair & replacement",
      "Running toilets & faucet leaks",
      "Low water pressure & pipe corrosion",
      "Sump pump & flooding issues",
    ],
    reasons: [
      "Upfront, flat-rate pricing — no surprises",
      "Licensed & insured NYC plumbers",
      "24/7 emergency response citywide",
      "Workmanship guarantee on every job",
    ],
    related: ["electrical", "hvac"],
  },
  {
    slug: "electrical",
    name: "Electrical",
    icon: "Zap",
    image: IMG.electrical,
    tagline: "Licensed Electricians in New York",
    short: "Panel upgrades, wiring, outlets, lighting, EV chargers, and code-compliant electrical work throughout New York.",
    seoTitle: "Electrician New York | Electrical Contractor & Panel Upgrades | " + business.name,
    seoDesc: "Licensed electrical contractor in New York. Panel upgrades, rewiring, lighting, outlets & EV chargers. Safe, code-compliant work. Free estimates.",
    overview:
      "Electrical problems aren't just inconvenient — they're a safety risk. Our licensed New York electricians deliver code-compliant panel upgrades, rewiring, lighting, and troubleshooting with safety as the top priority.",
    problems: [
      "Outdated or overloaded electrical panels",
      "Flickering lights & tripping breakers",
      "Faulty outlets & aluminum wiring",
      "Lighting & ceiling fan installation",
      "EV charger & generator installation",
      "Code violations & inspection prep",
    ],
    reasons: [
      "Fully licensed & insured electricians",
      "Every job meets NYC electrical code",
      "Transparent estimates before we start",
      "Clean, labeled, and safe installations",
    ],
    related: ["plumbing", "hvac"],
  },
  {
    slug: "hvac",
    name: "HVAC",
    icon: "Thermometer",
    image: IMG.hvac,
    tagline: "Heating & Cooling Experts in New York",
    short: "AC repair, heating installation, furnace service, and year-round HVAC maintenance for NYC homes & properties.",
    seoTitle: "HVAC Contractor New York | AC & Heating Repair | " + business.name,
    seoDesc: "HVAC contractor in New York for AC repair, heating installation, furnace service & maintenance. Stay comfortable year-round. Request a free estimate.",
    overview:
      "New York weather swings from brutal summers to freezing winters. Our HVAC technicians keep you comfortable year-round with fast AC repair, efficient heating installation, and preventative maintenance that lowers your bills.",
    problems: [
      "AC not cooling or blowing warm air",
      "Furnace & boiler breakdowns",
      "Uneven heating or cooling",
      "High energy bills & old systems",
      "Thermostat & ductwork issues",
      "New system installation & sizing",
    ],
    reasons: [
      "NATE-style trained HVAC technicians",
      "Energy-efficient system recommendations",
      "Fast repair when comfort can't wait",
      "Maintenance plans that extend system life",
    ],
    related: ["plumbing", "electrical"],
  },
];

export const getService = (slug) => services.find((s) => s.slug === slug);

export const projects = [
  {
    id: 1,
    category: "plumbing",
    before: PROJECT_IMG.plumbingBefore,
    after: PROJECT_IMG.plumbingAfter,
    caption: "Replaced corroded, leaking under-sink pipes with new clean copper lines in a Brooklyn brownstone.",
  },
  {
    id: 2,
    category: "electrical",
    before: PROJECT_IMG.electricalBefore,
    after: PROJECT_IMG.electricalAfter,
    caption: "Full panel upgrade — retired a hazardous tangled breaker box for a modern, labeled electrical panel in Queens.",
  },
  {
    id: 3,
    category: "hvac",
    before: PROJECT_IMG.hvacBefore,
    after: PROJECT_IMG.hvacAfter,
    caption: "Removed an old rusted condenser and installed a high-efficiency AC unit on a fresh pad in Staten Island.",
  },
];

export const testimonials = [
  { name: "Maria R.", location: "Manhattan, NY", service: "Plumbing", rating: 5, text: "Called at 6 AM with a burst pipe and they were at my door within the hour. Professional, clean, and fair pricing. Lifesavers." },
  { name: "James T.", location: "Brooklyn, NY", service: "Electrical", rating: 5, text: "Upgraded my whole panel and installed new lighting. The electrician explained everything and passed inspection first try." },
  { name: "Priya S.", location: "Queens, NY", service: "HVAC", rating: 5, text: "Our AC died in a July heatwave. They diagnosed it fast, gave honest options, and had us cool the same day. Highly recommend." },
  { name: "David L.", location: "Bronx, NY", service: "Plumbing", rating: 5, text: "Fixed a stubborn sewer backup other companies couldn't. Transparent estimate, no upsells. I've found my go-to contractor." },
  { name: "Angela M.", location: "Staten Island, NY", service: "HVAC", rating: 5, text: "New furnace installed before winter. Crew was on time, tidy, and respectful of my home. Bills already lower." },
  { name: "Kevin O.", location: "Manhattan, NY", service: "Electrical", rating: 5, text: "Installed an EV charger in my garage. Quick quote, quick install, and everything to code. Great experience." },
];

export const serviceAreas = [
  "Manhattan", "Brooklyn", "Queens", "The Bronx", "Staten Island",
  "Long Island City", "Astoria", "Williamsburg", "Park Slope", "Harlem",
  "Upper East Side", "Upper West Side", "Flushing", "Jamaica", "Riverdale",
  "Forest Hills", "Bay Ridge", "Chelsea", "Tribeca", "Greenpoint",
];

export const faqs = [
  { q: "Do you offer free estimates?", a: "Yes. We provide free, no-obligation estimates for plumbing, electrical, and HVAC projects across New York. Request one online or call us directly." },
  { q: "Are you licensed and insured?", a: "Absolutely. We are a fully licensed and insured New York contractor. License numbers are listed in our footer and available on request. (Placeholder license numbers — replace with real credentials.)" },
  { q: "Do you offer 24/7 emergency service?", a: "Yes. Plumbing, electrical, and HVAC emergencies don't wait for business hours, and neither do we. Call our emergency line any time, day or night." },
  { q: "Which areas of New York do you serve?", a: "We serve all five boroughs — Manhattan, Brooklyn, Queens, The Bronx, and Staten Island — plus many surrounding neighborhoods. See our Service Areas page for the full list." },
  { q: "How fast can you respond?", a: "For emergencies, we aim to be on-site within the hour whenever possible. For standard appointments, we typically schedule within 24–48 hours." },
  { q: "Do you offer financing?", a: "Yes. We offer flexible financing options on qualifying installations and larger repairs so you don't have to delay important work. Visit our Financing page to learn more." },
  { q: "Do you guarantee your work?", a: "Every job is backed by our workmanship guarantee. If something isn't right, we'll make it right. Warranty terms vary by service and product." },
  { q: "How do I get started?", a: "Simply call us or fill out our short Request a Free Estimate form. We'll confirm details, schedule a visit, and provide upfront pricing before any work begins." },
];

export const trustSignals = [
  { icon: "ShieldCheck", label: "Licensed & Insured" },
  { icon: "Clock", label: "24/7 Emergency Service" },
  { icon: "Award", label: `${business.yearsInBusiness}+ Years in Business` },
  { icon: "Star", label: "500+ 5-Star Reviews" },
];

export const ESTIMATE_PATH = "/contact"; // Request a Free Estimate destination

// ---- Demo / portfolio disclaimers ----
export const DEMO_DISCLAIMER =
  "This concept website was designed and built by Ananta Digital Works strictly for portfolio, SEO, and demonstration purposes. Empire Home Services NY is a fictional entity—this website is NOT an active business, does not dispatch technicians, and does not accept service requests or emergency calls.";

export const DEMO_PHONE_NOTICE =
  "Demo Site Notice: This phone number is for demonstration purposes only.";

export const DEMO_FORM_CONFIRMATION =
  "Thank you for testing our demo form. No actual estimate request has been dispatched.";

// Agency credit. Set `url` to Ananta Digital Works' website when available.
export const AGENCY = { name: "Ananta Digital Works", url: "" }; // TODO: PASTE AGENCY URL
